import { MessageCircle } from "lucide-react";

const FloatingWhatsApp = () => {
  const phoneNumber = "905075537051";
  const message = encodeURIComponent("Merhaba, eşya satmak istiyorum. Bilgi alabilir miyim?");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <div className="floating-whatsapp" data-testid="floating-whatsapp">
      {/* Pulse ring effect */}
      <div className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
      
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-whatsapp-btn relative"
        data-testid="floating-whatsapp-btn"
        aria-label="WhatsApp ile iletişime geçin"
      >
        <MessageCircle className="w-7 h-7" />
      </a>
      
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-slate-800 text-white text-sm rounded-lg whitespace-nowrap opacity-0 hover:opacity-100 transition-opacity pointer-events-none">
        Resim Yolla & Teklif Al
      </div>
    </div>
  );
};

export default FloatingWhatsApp;
